import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Menu } from '../../menu/menu.model';
import { MenuService } from '../../menu/menu.service';
import { MenuItem } from '../menuItem.model';
import { MenuitemsService } from '../menuitems.service';

@Component({
  selector: 'app-addmenuitems',
  templateUrl: './addmenuitems.component.html',
  styleUrls: ['./addmenuitems.component.css']
})
export class AddmenuitemsComponent implements OnInit {

  menus: Menu[] = [];
  menuItem: MenuItem = {} as MenuItem;
  updateMode = false;
  spinnerOverlay = false;
  lang: any;

  constructor(private router: Router,
    private menuService: MenuService,
    private service: MenuitemsService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private activateRoute: ActivatedRoute,
    private translate: TranslateService,
    private localStorage: LocalStorageService) { }

  ngOnInit(): void {
    this.lang = this.localStorage.retrieve("lang");
    this.getMenu();
    this.getUrlParam();
  }

  getMenu() {
    this.menuService.getAll().subscribe(data => {
      this.menus = data;
    },
      error => {
        console.log(error);
      })
  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.menuItem.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  getById() {
    this.spinnerOverlay = true;
    this.service.getById(this.menuItem.id).subscribe(data => {
      this.menuItem = data
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

  back() {
    this.router.navigate(["./master/systemsettings/menuitems"]);
  }

  submit() {
    this.spinnerOverlay = true;
    !this.updateMode ? this.create() : this.update();
  }

  create() {

    this.service.Create(this.menuItem).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  update() {

    this.service.Update(this.menuItem).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

      })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

}
